/**
 * pz.viewportModal
 * 
 * Controls the generic viewport modal window.
 * Can be passed either a url to load or html.
 * 
 * Requires: jquery
 */

$(function () {
    'use strict';

    if (window.pz === undefined) {
        window.pz = {};
    }

    pz.viewportModal = function () {

        var initModule = function () {

            $('.js-modal-close-button').click(function (event) {
                close();
            });

            // TODO: could also use global listener; see util modals for example
            $('.js-viewport-overlay').click(function (event) {
                close();
            });

            // handle continue shopping button
            $('.js-viewport-modal').on('click', '.js-continue-shopping-button', function() {
                close();
                // reload the product variant to redefine the group id, and reset 'add to cart' button
                pz.products.loadVariant();
            });

            // handle view cart button
            $('.js-viewport-modal').on('click', '.js-view-cart-button', function() {
                close();
                // redirect to cart 
                location.href='/cart';
            });
        };

        var load = function (url, html) {
            if (url) {
                // load from url
                $('#viewport .js-modal-body').load(url, show);
            } else {
                $('#viewport .js-modal-body').html(html);
                show();
            }
        };

        var show = function () {
            var yoff = $(window).scrollTop() + $(window).height() / 2;

            // temporarily show to set position
            $('.js-viewport-modal').show();
            yoff -= $('.js-modal-container').height() / 2;
            $('.js-modal-container').css({ 'top': yoff });
            $('.js-viewport-modal').hide();

            // display
            $('.js-viewport-modal').fadeIn(200);
        };

        var close = function () {
            $('.js-viewport-modal').fadeOut(200);
        };

        return {
            initModule: initModule,
            show: show,
            load: load,
            close: close
        };
    }();

    pz.viewportModal.initModule();
});